<template>
  <Modal :id="'cmp-free-dates'" @cancelled="onCancelClick">
    <template slot="header">{{ $t("booking_artist_free_dates") }}</template>
    <template slot="body">
      <v-layout row wrap my-4 class="artist-bar" v-if="!artistIdR">
        <Dropdown
          class="m2"
          :options="artistsTV"
          :selected="artistsTV.find((e) => e.value == selectedArtist)"
          :placeholder="$t('artist')"
          box
          v-on:selectedChange="(e) => onArtistSelected(e)"
        ></Dropdown>
      </v-layout>
      <v-layout row wrap my-4>
        <v-flex md1 v-for="month of months" :key="month.value">
          <v-layout row wrap>
            <v-flex md3>
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="month.value"
                  :id="month.value"
                  :checked="selectedMonths.has(month.value)"
                  @click="(e) => onMonthSelected(e, month)"
                />
                <!-- <div class="checkmark" :style="{ 'backgroundColor': month.color, 'borderColor': month.borderColor }"></div> -->
                <div class="checkmark"></div>
              </div>
            </v-flex>
            <v-flex md9>
              <div class="month-text">
                {{ month.text }}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap my-4>
        <v-flex md1 v-for="day of days" :key="day.value">
          <v-layout row wrap>
            <v-flex md3>
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="day.value"
                  :id="day.value"
                  :checked="selectedDays.has(day.value)"
                  @click="(e) => onDaySelected(e, day)"
                />
                <!-- <div class="checkmark" :style="{ 'backgroundColor': day.color, 'borderColor': day.borderColor }"></div> -->
                <div class="checkmark"></div>
              </div>
            </v-flex>
            <v-flex md9>
              <div class="month-text">
                {{ day.text }}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout my-4 row wrap ref="artistFreeDates" class="artist-free-dates">
        <h2 class="artist-name">{{ selectedArtistName }}</h2>

        <div v-if="freeDates" class="months-list">
          <div class="month-item" v-for="month of freeDates" :key="month.month">
            <div class="month-name">
              {{ capitalizeFirst(month.month_name) }}
            </div>
            <div class="month-dates">
              {{ month.days.join(" / ") }}
            </div>
          </div>
        </div>
      </v-layout>
    </template>
    <template slot="options">
      <button
        class="dt-button s7 v1"
        style="max-width: 185px"
        @click="onCopyClick"
      >
        {{$t('copy_results_to_clipboard')}}
      </button>
      <button class="dt-button s6" @click="onCancelClick"> {{$t('cancel')}} </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { format } from "date-fns";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace,
} from "../store";
import * as ActionTypes from "../store/types";
import { getNextMonths, getWeekDays } from "../../../utility/calendar";
import randomColor from "randomcolor";

import DtTab from "@plugins/tab/tab";
import { mapGetters } from "vuex";
import { addRemoveSet, capitalizeFirst, copyText } from "../../../utility";
import { BookingService } from "../services/booking-service";
import { REQUEST_CANCELLED } from "../../../services/http/error-handler";
import { createHttpGetOptions } from "../../../services/http/http-client";
import { HttpLib } from "../../../services/http/http-lib";

import Modal from "../../../dt-plugins/modal/modal";
import { toString } from "ramda";
import { createTV } from "../../../models/text-value.model";

export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
      freeDateFetchTokenSource: null,

      selectedMonths: new Set(),
      selectedDays: new Set([5, 6, 0].map(toString)),

      selectedArtist: null,

      freeDates: null,
      // Mark: Data
    };
  },
  mounted: async function () {
    // const artists = await BookingService.initArtistFreeDates();
    // console.log("artists", artists);
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
    artistsTV: {
      immediate: true,
      handler: function (to, from) {
        // Set Default selectedArtist
        if(this.artistIdR){
          this.selectedArtist = this.artistIdR;
        }
        else if (!this.selectedArtist && to.length > 0) {
          this.selectedArtist = to?.[0]?.value;
        }
      },
    },
    months: {
      immediate: true,
      handler: function (to, from) {
        if (to.length > 0) {
          this.selectedMonths = new Set([to[0].value]);
          this.makeRequest();
        }
      },
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      artists: "artists",
    }),

    artistsTV() {
      return createTV(this.artists, "artist_name", "artist_id");
    },

    months: function () {
      return getNextMonths().map((e) => ({
        text: format(e, "MMMM"),
        value: format(e, "YYYY-MM"),
        color: randomColor({
          luminosity: "dark",
          format: "rgb",
        }),
        borderColor: randomColor({
          luminosity: "light",
          format: "rgba",
        }),
      }));
    },
    days: function () {
      return getWeekDays().map((e) => ({
        text: format(e, "ddd"),
        value: format(e, "d"),
        color: randomColor({
          luminosity: "dark",
          format: "rgb",
        }),
        borderColor: randomColor({
          luminosity: "light",
          format: "rgba",
        }),
      }));
    },
    selectedArtistName() {
      return this.artistsTV?.find((e) => e.value == this.selectedArtist)?.text;
    },
    artistIdR: function () {
      return this.$route.params.artist_id;
    },
  },
  methods: {
    onMonthSelected: function (e, month) {
      this.selectedMonths = addRemoveSet(
        e.target.checked,
        this.selectedMonths,
        month.value
      );
      this.makeRequest();
    },
    onArtistSelected: function (artist) {
      // console.log(artist);
      this.selectedArtist = artist.value;
      this.makeRequest();
    },
    onDaySelected: function (e, day) {
      this.selectedDays = addRemoveSet(
        e.target.checked,
        this.selectedDays,
        day.value
      );
      this.makeRequest();
    },
    makeRequest: function () {
      if (
        !this.selectedArtist ||
        this.selectedMonths.size === 0 ||
        this.selectedDays.size === 0
      ) {
        return;
      }


      let source, cancelToken;
      

      if (this.freeDateFetchTokenSource) {
        this.freeDateFetchTokenSource.cancel(REQUEST_CANCELLED);
      }
      this.freeDateFetchTokenSource = HttpLib.CancelToken.source();
      cancelToken = this.freeDateFetchTokenSource.token;

      BookingService.findArtistFreeDates(
        {
          months: `[${Array.from(this.selectedMonths)
            .map(toString)
            .join(",")}]`,
          days: `[${Array.from(this.selectedDays).map(toString).join(",")}]`,
          artistId: this.selectedArtist,
        },
        createHttpGetOptions({
          cancelToken: cancelToken,
        })
      ).then((res) => {
        // console.log(res);
        this.freeDates = res.data.free_dates;
      });
    },
    capitalizeFirst: function (string) {
      return capitalizeFirst(string);
    },
    onCopyClick: function (event) {
      // console.log('on Copy Clicked');
      // console.log(this.$refs['artistFreeDates'].innerText);
      copyText(this.$refs["artistFreeDates"].innerText);
    },
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped>
.artist-bar {
}

.dropdown {
  flex: 5;
  max-width: 200px;
}

.artist-free-dates {
  flex-direction: column;
  color: var(--text-2);

  .artist-name {
    margin: 20px 0px;
  }

  .months-list {
    .month-item {
      display: flex;
      margin: 10px 0px;
      .month-name {
        flex: 1;
        font-weight: 500;
      }
      .month-dates {
        flex: 11;
      }
    }
  }
}
</style>
